import { api } from "@/lib/api";
import { Account, ApiResponse } from "@/lib/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useGetAccounts = (
  options?: Omit<
    UseQueryOptions<ApiResponse<Account[]>>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery<ApiResponse<Account[]>>({
    queryKey: ["accounts"],
    queryFn: async () => {
      const response = await api.get("/accounts");
      return response.data;
    },
    ...options,
  });
};

export const useGetAccountById = (
  id?: string,
  options?: Omit<UseQueryOptions<ApiResponse<Account>>, "queryKey" | "queryFn">
) => {
  return useQuery<ApiResponse<Account>>({
    queryKey: ["account-detail", id],
    queryFn: async () => {
      const response = await api.get(`/accounts/${id}`);
      return response.data;
    },
    enabled: !!id,
    ...options,
  });
};

export const useGetAccountsByVesselId = (
  vesselId?: string,
  options?: Omit<
    UseQueryOptions<ApiResponse<Account[]>>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery<ApiResponse<Account[]>>({
    queryKey: ["accounts-by-vessel-id", vesselId],
    queryFn: async () => {
      const response = await api.get(`/accounts/by-vessel/${vesselId}`);
      return response.data;
    },
    enabled: !!vesselId,
    ...options,
  });
};
